import CommonApi from '@/api/common';
import { Debounce } from '@/shared/decorators/debounce';

import { Popup, Field } from 'vant';
import { Toast } from '@hb/coffee';
import {
  Vue, Model, Watch, Component, Prop,
} from 'vue-property-decorator';

import style from './index.module.scss';

const C0UNT_INTERVAL = 60;
@Component({
  name: 'MeassgePopup',
})
export default class MeassgePopup extends Vue {
  /** 手机号 */
  @Prop(String) readonly phone!: string;

  /** 页面版本 */
  @Prop(String) readonly pageVersion!: string;


  /** 按钮文案 */
  @Prop(String) readonly buttonName!: string;

  @Model('change', {
    type: Boolean,
  })
  private messagePop!: boolean;

  private code?: string;

  private showMessage = false;

  /** 清除当前定时器 */
  private resetTimer() {
    this.isCounting = false;
    this.countSeconds = C0UNT_INTERVAL - 1;
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  @Watch('messagePop')
  private popVisale(val: boolean) {
    // 弹窗显示 曝光埋点
    if (val) {
      this.countDown();
      this.$ubtModuleExpose(
        'finance_smsMarketing_landingPage_otpPopup',
      );
    }
  }

  private errorTips = '';

  /** 确认，查看我的额度 */
  @Debounce(300)
  private async onConfirm() {
    let platformUserInfo;
    // 登录并且回调
    if (this.code) {
      this.$ubtPageButton(
        'finance_smsMarketing_landingPage_login',
        'pageVersion',
        this.pageVersion,
      );
      try {
        platformUserInfo = await CommonApi.login(
          this.phone,
          this.code,
          true,
        );
        this.$emit('confirm', platformUserInfo);
      } catch (error) {
        const { message } = error as unknown as { message: '' };
        this.errorTips = message || '验证码输入错误，请重新输入';
        this.showMessage = true;
      }
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      Toast('请输入验证码');
    }
  }

  /** 关闭 */
  private onClosedPopup() {
    this.resetTimer();
    this.code = '';
    this.showMessage = false;
    this.$emit('close');
  }

  /** 标记倒计时开始 秒数 */
  private countSeconds = C0UNT_INTERVAL - 1;

  /** 标记当前是否倒计时阶段 */
  private isCounting = false;

  private timer: NodeJS.Timer | null = null;

  /** 倒计时 */
  private countDown() {
    this.isCounting = true;
    this.timer = null;
    this.timer = setInterval(() => {
      --this.countSeconds;
      if (this.countSeconds === 0) {
        this.resetTimer();
      }
    }, 1000);
  }

  /** 重新获取验证码 */
  private countBind(): void {
    if (this.isCounting) {
      return;
    }
    this.countDown();
    this.$emit('reSendCode');
    this.$ubtPageButton(
      'finance_smsMarketing_landingPage_otp',
      'pageVersion',
      this.pageVersion,
    );
  }

  private get countDownText() {
    return `${this.countSeconds}s后重新获取`;
  }

  private render() {
    return (
      <Popup
        v-model={this.messagePop}
        class={[style['message-pop'], style['popup-radius']]}
        postion="center"
        onClose={this.onClosedPopup.bind(this)}
        closeOnClickOverlay={false}
      >
        <section class={style['main-content']}>
          <div class={style['text-content']}>
            <div class={[style.title]}>
              <span class={style['title-text']}>手机号验证</span>
              <span class={style.closed} onClick={this.onClosedPopup.bind(this)}></span>
            </div>
            <div class={style['message-pop-content']}>
              <div class={style['verfication-text']}>
                验证码已发送：<span class={style['verfication-mobile']}>{this.phone}</span>
              </div>
              <div class={style['coupon-item']}></div>
              <div class={style['verify-input-wrapper']}>
                <Field
                  class={style['verify-input']}
                  v-model={this.code}
                  placeholder="请输入验证码"
                  maxlength="4">
                  <div slot="button" class={
                    [style['verify-status-avaliable'],
                      this.isCounting && style['verify-status-unavaliable']]}
                    onClick={this.countBind.bind(this)}
                  >
                    {this.isCounting ? this.countDownText : '重新获取'}
                  </div>
                </Field>
                {this.showMessage
                  && <div class={style['error-message']}>{this.errorTips}</div>}
              </div>
              <div class={style['button-review']}
                onClick={this.onConfirm.bind(this)}
              >下载APP</div>
            </div>
          </div>
        </section>
      </Popup>

    );
  }
}
